/**
 * Tiny role-memory helper: speichert die zuletzt gewählte Funnel-Rolle des
 * Besuchers in localStorage, damit z. B. die Trust-Stripe im Header
 * kontextabhängig in das passende Premium-Bundle linken kann.
 *
 * Rollen-Mapping:
 *   "pflegekraft", "angehoerig"  → B2C  → Pflegekraft-Bundle
 *   "pdl", "leitung", "qm",
 *   "inhaber", "abrechnung"     → B2B  → Cash-Bundle (Default für PDL)
 *   "andere", null              → unbekannt → Bundle-Hub
 */

const KEY = "dh-user-role";

const B2C_ROLES = new Set(["pflegekraft", "angehoerig"]);
const B2B_ROLES = new Set(["pdl", "leitung", "qm", "inhaber", "abrechnung"]);

export function setUserRole(role) {
  if (!role) return;
  try { localStorage.setItem(KEY, String(role)); } catch {
    // Private mode etc. – stillschweigend ignorieren.
  }
}

export function getUserRole() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

/**
 * Kontext-Bundle-CTA für die Trust-Stripe.
 * Gibt `{ href, text, subText?, ctaText }` zurück.
 *
 * Seit Feb 2026: Pflege-KI ist das Flaggschiff-Feature → einheitlicher
 * Pflege-KI-Stripe für ALLE Besucher (Wortlaut vom Product-Owner vorgegeben,
 * Nutzen first, Tech in Subline). Frühere rollenspezifische Bundle-Funnel
 * (B2C/B2B) sind bewusst deaktiviert.
 */
export function getContextualBundleCta() {
  return {
    href: "/campus/pro",
    text: "Digitale Patientenmappe f\u00FCr Pflegedienste — 11 Sektionen, 26 QPR-Kriterien, Team-Chat.",
    subText: "SIS-Diktat \u00B7 Full-PDF-Export \u00B7 Halluzinationsschutz \u00B7 ab 199 \u20AC / Monat.",
    ctaText: "Pflege-KI kennenlernen \u2192",
  };
}
